import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, LayoutList, Bell, Inbox, TrendingUp,
} from "lucide-react";

export function MobileBottomNav({
  profile,
  notifCount,
  showNotif,
  showMobileMenu,
  onToggleNotif,
  onOpenMobileMenu,
  notifBtnRef,
}) {
  const userInitial = profile?.first_name?.[0]?.toUpperCase() || profile?.email?.[0]?.toUpperCase() || "A";

  const itemCls = (isActive) =>
    `flex-1 h-full flex flex-col items-center justify-center gap-1 pt-1.5 pb-1 transition-colors ${isActive ? "text-[#ffc700]" : "text-gray-500"}`;

  const iconBox = "flex items-center justify-center h-6 w-6 flex-shrink-0";
  const label = "text-[9px] font-bold uppercase tracking-wider leading-none";

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 bg-[#111] border-t border-white/[0.08] flex flex-col z-50"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex h-16 w-full">
        <NavLink to="/home" data-testid="nav-home" className={({ isActive }) => itemCls(isActive)}>
          <div className={iconBox}>
            <LayoutDashboard size={22} />
          </div>
          <span className={label}>Inicio</span>
        </NavLink>

        <NavLink to="/pipeline" data-testid="nav-pipeline" className={({ isActive }) => itemCls(isActive)}>
          <div className={iconBox}>
            <LayoutList size={22} />
          </div>
          <span className={label}>Pipeline</span>
        </NavLink>

        <NavLink to="/inbox" data-testid="nav-inbox-mobile" className={({ isActive }) => itemCls(isActive)}>
          <div className={iconBox}>
            <Inbox size={22} />
          </div>
          <span className={label}>Inbox</span>
        </NavLink>

        <NavLink to="/finance" data-testid="nav-finance-mobile" className={({ isActive }) => itemCls(isActive)}>
          <div className={iconBox}>
            <TrendingUp size={22} />
          </div>
          <span className={label}>Finanzas</span>
        </NavLink>

        <button
          ref={notifBtnRef}
          data-testid="notif-bubble-mobile"
          onClick={onToggleNotif}
          className={`flex-1 h-full flex flex-col items-center justify-center gap-1 pt-1.5 pb-1 relative transition-colors ${showNotif ? "text-[#ffc700]" : "text-gray-500"}`}
        >
          <div className={`${iconBox} relative`}>
            <Bell size={22} />
            {notifCount > 0 && (
              <span
                data-testid="notif-badge-mobile"
                className="absolute -top-1 -right-1.5 min-w-[16px] h-[16px] bg-red-500 text-white text-[9px] font-black rounded-full flex items-center justify-center px-0.5 border border-[#111] leading-none"
              >
                {notifCount > 9 ? "9+" : notifCount}
              </span>
            )}
          </div>
          <span className={label}>Alertas</span>
        </button>

        <button
          data-testid="nav-profile-mobile"
          onClick={onOpenMobileMenu}
          className={`flex-1 h-full flex flex-col items-center justify-center gap-1 pt-1.5 pb-1 relative transition-colors ${showMobileMenu ? "text-[#ffc700]" : "text-gray-500"}`}
        >
          <div className={iconBox}>
            {profile?.avatar
              ? <img src={profile.avatar} alt="avatar" className="w-[22px] h-[22px] rounded-full object-cover border border-white/20 block" />
              : <div className="w-[22px] h-[22px] rounded-full bg-gradient-to-br from-[#ffc700] to-[#ff8c00] flex items-center justify-center text-black text-[10px] font-black leading-none">{userInitial}</div>
            }
          </div>
          <span className={label}>Más</span>
        </button>
      </div>
    </nav>
  );
}
